// Today during week one: the part of the homecoming plan that matters now.

import { ChevronRight, Home, Moon } from 'lucide-react';
import { useLiveStatus, useProfile } from '../../data/hooks.ts';
import { currentSections, planDay } from '../../domain/homecoming.ts';
import { navigate } from '../../app/router.ts';
import { Card } from '../../ui/primitives.tsx';
import { PlanRow, useTicks } from './plan.tsx';

export function WeekOneCard() {
  const profile = useProfile();
  const s = useLiveStatus(60_000);
  const ticks = useTicks();
  const day = planDay(profile.homeDate, s.now);
  const sections = currentSections(day, s.now);
  if (!sections.length) return null;
  const main = sections.find((x) => x.id !== 'breeder') ?? sections[0];
  // Show what's left first; keep it short enough for the kiosk.
  const items = [main, ...sections.filter((x) => x !== main)].flatMap((x) => x.items);
  const left = items.filter((i) => !ticks.get(i.id)?.done);
  const shown = (left.length ? left : items).slice(0, 4);
  const Icon = main.part === 'night' ? Moon : Home;
  return (
    <Card className="weekone-card">
      <div className="brief-head">
        <span className="eyebrow">
          <Icon aria-hidden width={14} /> {day === 0 ? (main.part === 'night' ? 'Tonight' : 'Today') : `Week one · day ${day}`}
        </span>
        <button type="button" className="link small" onClick={() => navigate('/homecoming')}>
          Full plan <ChevronRight aria-hidden width={14} />
        </button>
      </div>
      <strong className="brief-title">{main.title}</strong>
      <ul className="plan-list compact">
        {shown.map((i) => (
          <PlanRow key={i.id} item={i} done={!!ticks.get(i.id)?.done} by={ticks.get(i.id)?.by} />
        ))}
      </ul>
      {left.length > shown.length && <span className="muted small">+{left.length - shown.length} more in the plan</span>}
      {!left.length && <span className="muted small">All done for today — lovely work.</span>}
    </Card>
  );
}
